import { Flex } from '@brokerbay/elements-web';
import { Button, PreviewButton, theme } from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import AppointmentBookingInternalContext from './AppointmentBookingInternalContext';

type HeaderButtonsProps = {
  goToListingViewPage: () => void;
};

const HeaderButtons: React.FC<HeaderButtonsProps> = ({
  goToListingViewPage,
}) => {
  const { actionButtonsData, listing } = useContext(
    AppointmentBookingInternalContext,
  );

  if (!listing) return null;

  return (
    <Flex gap="small">
      <PreviewButton listing={listing} listingId={listing.id} />
      {actionButtonsData.map(({ variant, onClick, disabled }) => {
        if (variant === 'book')
          return (
            <Button
              key={variant}
              onClick={onClick}
              disabled={disabled}
              type="primary"
              data-cy="submit-appointment"
            >
              Request Showing
            </Button>
          );
        if (variant === 'confirm')
          return (
            <StyledConfirmButton
              key={variant}
              onClick={onClick}
              type="default"
              disabled={disabled}
              data-cy="submit-appointment-confirm"
            >
              Book & Confirm
            </StyledConfirmButton>
          );
        if (variant === 'autoConfirm')
          return (
            <Button
              key={variant}
              onClick={onClick}
              type="primary"
              disabled={disabled}
              data-cy="submit-appointment"
            >
              Book & Confirm
            </Button>
          );
        if (variant === 'record') {
          return (
            <Button
              key={variant}
              onClick={onClick}
              disabled={disabled}
              type="primary"
              data-cy="record-appointment"
            >
              Record Showing
            </Button>
          );
        }
        return (
          <Button
            key={variant}
            onClick={onClick}
            disabled={disabled}
            type="primary"
            data-cy="submit-virtual-tour"
          >
            Add Property to Tour
          </Button>
        );
      })}

      <Button data-cy="cancel-appointment" onClick={goToListingViewPage}>
        Cancel
      </Button>
    </Flex>
  );
};

export default HeaderButtons;

const StyledConfirmButton = styled(Button)`
  background-color: ${theme.green9};
  color: white;
  border: 0;
  &:hover {
    background-color: ${theme.green8};
    color: white;
  }
`;
